import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.css';
import { Link, useParams } from 'react-router-dom';
import { getMentorById } from '../../../../redux/features/staff/staffService';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import Skeleton from 'react-loading-skeleton';

const InstructorProfile = () => {

    const dispatch = useDispatch();
    const { id } = useParams();

    const { mentorDetails, isMentorLoading } = useSelector((state) => state.staff.mentorDetails);

    useEffect(() => {
        dispatch(getMentorById({ id }))
    }, [dispatch, id]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [id]);

    const linkedinUrl = mentorDetails?.linkedin_account?.startsWith("http")
        ? mentorDetails?.linkedin_account
        : `https://${mentorDetails?.linkedin_account}`;

    return (
        <div className={`main-container`}>
            <div className={`container-content`}>
                <>
                    {isMentorLoading ?
                        <div className={styles.insProfileSec}>
                            <div className={styles.profileCard}>
                                <Skeleton className={styles.profileImg} />
                                <div className={styles.profileDetails}>
                                    <p className={styles.mentorName}><Skeleton/></p>
                                    {/* <Skeleton className={styles.mentorEmail} width={300}/> */}
                                    <Skeleton className={styles.mentorDesignation}/>
                                    <Skeleton className={styles.mentorLI} />
                                </div>
                            </div>
                            <div className={styles.profileAboutMe}>
                                <h3><Skeleton width={100}/></h3>
                               <Skeleton className={styles.mentorBio} count={5}/>
                            </div>
                            <div className={styles.profileQualifications}>
                                <h3><Skeleton width={100}/></h3>
                                 <Skeleton className={styles.mentorBio} count={4} width={300}/>                               
                                <h3><Skeleton width={100}/></h3>
                                <Skeleton className={styles.mentorBio} count={4} width={300}/>   
                            </div>
                        </div>
                        : <div className={styles.insProfileSec}>
                            <div className={styles.profileCard}>
                                <img src={mentorDetails?.image_url} alt='mentor' className={styles.profileImg} />
                                <div className={styles.profileDetails}>
                                    <p className={styles.mentorName}>{mentorDetails?.full_name}</p>
                                    {/* <p className={styles.mentorEmail}>{mentorDetails?.email}</p> */}
                                    <p className={styles.mentorDesignation}>{mentorDetails?.designation}</p>
                                    <a
                                        href={linkedinUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FontAwesomeIcon icon={faLinkedin} className={styles.mentorLI} />
                                    </a>
                                </div>
                            </div>
                            <div className={styles.profileAboutMe}>
                                <h3>About Me</h3>
                                <p className={styles.mentorBio}>{mentorDetails?.bio}</p>
                            </div>
                            <div className={styles.profileQualifications}>
                                <h3>Qualifications</h3>
                                {mentorDetails?.mentor_qualifications?.map((qualification) => (
                                    <p className={styles.mentorBio} key={qualification?.id}>{qualification?.degree_or_certificate}, {qualification?.school_or_university}</p>
                                ))}
                                <h3>Experience</h3>
                                {mentorDetails?.mentor_experiences?.map((experience) => (
                                    <p className={styles.mentorBio} key={experience?.id}>{experience?.designation} {experience?.organization?.name}</p>
                                ))}
                            </div>
                        </div>
                    }
                </>
            </div>
        </div>
    )
}

export default InstructorProfile;